/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleListVm
 */
export interface RoleListVm {
    /**
     * 
     * @type {string}
     * @memberof RoleListVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleListVm
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleListVm
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListVm
     */
    isBuiltIn?: boolean;
}

export function RoleListVmFromJSON(json: any): RoleListVm {
    return RoleListVmFromJSONTyped(json, false);
}

export function RoleListVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleListVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isBuiltIn': !exists(json, 'isBuiltIn') ? undefined : json['isBuiltIn'],
    };
}

export function RoleListVmToJSON(value?: RoleListVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'isBuiltIn': value.isBuiltIn,
    };
}


